import React, { Component } from 'react';
import _ from 'lodash';
import dayjs from 'dayjs';
import {
  Form,
  Radio,
  Checkbox,
  DatePicker,
  Select,
  Input,
  Button,
  Tooltip,
  Icon,
  Row,
  Col,
} from 'antd';
import SelectTenant from '@/components/SelectTenant';
import SelectUser from '@/components/SelectUser';
import FilterItem from '@/components/FilterItem';
import styles from './filter.module.scss';
import * as utils from '@/utils';
import * as apis from '@/apis';
import { orderStatus } from '@/models/orders/defines/constants';

const tenantMode = process.env.APP_MODE === 'tenant';
const { RangePicker } = DatePicker;
const payerTypeOptions = [
  { label: '全部', value: 0 },
  { label: '保内', value: 1 },
  { label: '保外', value: 2 },
];
const orderTypeOptions = [
  { label: '全部', value: 0 },
  { label: '安装', value: 1 },
  { label: '维修', value: 2 },
];
// const orderTagsOptions = [
//   { label: '上门失败', value: 'TAG_SERVICE_FAILD' },
//   { label: '等待返件', value: 'TAG_WAIT_EXPRESS' },
//   { label: '等待发件', value: 'TAG_WAIT_SEND_EXPRESS' },
// ];

const managerOrderTagsOptions = [
  { label: '照片不规范', value: '照片不规范' },
  { label: '核实未完成', value: '核实未完成' },
  { label: '待返件', value: '待返件' },
  { label: '待发件', value: '待发件' },
  { label: '已发件', value: '已发件' },
];

const tenantOrderTagsOptions = [
  { label: '待返件', value: '待返件' },
  { label: '待发件', value: '待发件' },
];

const orderCaptchaOptions = [
  { label: '是', value: true },
  { label: '否', value: false },
];
@Form.create({
  onValuesChange: (props, changedValues, values) => {
    if (values.time_range && values.time_range[0] && values.time_range[1]) {
      values.time_range = [
        values.time_range[0].startOf('day').valueOf(),
        values.time_range[1].endOf('day').valueOf(),
      ];
    } else {
      delete values.time_range;
    }

    if (values.time_range2 && values.time_range2[0] && values.time_range2[1]) {
      values.time_range2 = [
        values.time_range2[0].startOf('day').valueOf(),
        values.time_range2[1].endOf('day').valueOf(),
      ];
    } else {
      delete values.time_range2;
    }

    values = _.pickBy(values, _.identity);

    props.onChange(values);
  },
})
export default class Filters extends Component {
  normalizeTenant = (value, prevValue, allValues) => {
    if (typeof value === 'string') {
      return value;
    }
    if (value && value._id) {
      return value._id;
    }
    return null;
  };
  render() {
    const { getFieldDecorator } = this.props.form;
    const { query = {} } = this.props;
    const downloadUrl = apis.getOrdersDumpUrl(query);
    return (
      <Form layout="inline">
        <div className={styles.filters}>
          <FilterItem className={styles.row} label="查询">
            {getFieldDecorator('keyword', {
              initialValue: query.keyword || null,
            })(<Input style={{ width: 160 }} placeholder="订单号/姓名/手机号" suffix={
              <Icon type="search" />
            } />)}
          </FilterItem>
          {!tenantMode && (
            <FilterItem className={styles.row} label="企业">
              {getFieldDecorator('tenant', {
                normalize: this.normalizeTenant,
                initialValue: query.tenant || null,
              })(
                <SelectTenant
                  style={{ width: 160 }}
                  placeholder="输入企业名称"
                />
              )}
            </FilterItem>
          )}
            <FilterItem
              className={styles.row}
              label={
                <Tooltip title="请注意：此处指的是创建订单的人，订单可能被转移到其他企业员工名下。">
                  <div style={{ display: 'inline-flex', alignItems: 'center' }}>
                    下单人
                    <i
                      className="iconfont"
                      style={{
                        fontSize: 14,
                        color: '#ccc',
                        marginRight: 5,
                        cursor: 'pointer',
                      }}
                    >
                      &#xe702;
                    </i>
                  </div>
                </Tooltip>
              }
            >
              {getFieldDecorator('createdBy', {
                initialValue: query.createdBy || null,
              })(
                <SelectUser
                  type="user"
                  style={{ width: 160 }}
                  selectKey="_id"
                  placeholder="输入下单人名称"
                />
              )}
            </FilterItem>
          {!tenantMode && (
            <FilterItem className={styles.row} label="师傅">
              {getFieldDecorator('worker', {
                initialValue: query.worker || null,
              })(
                <SelectUser
                  type="worker"
                  style={{ width: 160 }}
                  selectKey="_id"
                  placeholder="输入师傅名称"
                />
              )}
            </FilterItem>
          )}
          {!tenantMode && (
            <FilterItem className={styles.row} label="客服">
              {getFieldDecorator('assignTo', {
                initialValue: query.assignTo || null,
              })(
                <SelectUser
                  type="manager"
                  style={{ width: 160 }}
                  selectKey="user._id"
                  placeholder="输入客服名称"
                />
              )}
            </FilterItem>
          )}
          <FilterItem className={styles.row} label="服务类型">
            {getFieldDecorator('order_type', {
              initialValue: query.order_type || 0,
            })(
              <Select style={{ width: 120 }}>
                {orderTypeOptions.map((item, index) => <Select.Option key={index} value={item.value}>{item.label}</Select.Option>)}
              </Select>
            )}
          </FilterItem>
          <FilterItem className={styles.row} label="保修类型">
            {getFieldDecorator('payer_type', {
              initialValue: query.payer_type || 0,
            })(
              <Select style={{ width: 120 }}>
                {payerTypeOptions.map((item, index) => <Select.Option key={index} value={item.value}>{item.label}</Select.Option>)}
              </Select>
            )}
          </FilterItem>
          <FilterItem className={styles.row} label="工单类型">
            {getFieldDecorator('order_flag', {
              initialValue: query.order_flag || null,
            })(
              <Select style={{ width: 120 }}>
                <Select.Option value={null}>全部</Select.Option>
                <Select.Option value={0}>报价工单</Select.Option>
                <Select.Option value={1}>一口价工单</Select.Option>
              </Select>
            )}
          </FilterItem>

          <FilterItem className={styles.row} label="订单状态">
            {getFieldDecorator('status_code', {
              initialValue: query.status_code || null,
            })(
              <Select style={{ width: 120 }}>
                <Select.Option value={null}>全部</Select.Option>
                {Object.keys(utils.orderStatusMappings).filter(item => {
                  return [
                    orderStatus.WAIT_ASSIGN,
                    orderStatus.PROCESSING_WAIT_APPOINTMENT,
                    orderStatus.PROCESSING_WAIT_SERVICE,
                    orderStatus.WORKER_LOCATION_CHECKED,
                    orderStatus.PROCESSING_COMPLETED,
                    orderStatus.DONE_CLOSE,
                    orderStatus.CANCEL,
                    orderStatus.GUAQI,
                  ].includes(Number(item))
                }).map((key) => (
                  <Select.Option key={key} value={key}>
                    {utils.orderStatusMappings[key].text}
                  </Select.Option>
                ))}
              </Select>
            )}
          </FilterItem>
          <FilterItem className={styles.row} label="工单价格">
            <Row gutter={[6, 6]}>
              <Col span={11}>
                {getFieldDecorator('sprice', {
                  initialValue: query.sprice || null,
                })(<Input style={{ width: 80 }} />)}
              </Col>
              <Col span={2}>—</Col>
              <Col span={11}>
                {getFieldDecorator('eprice', {
                  initialValue: query.eprice || null,
                })(<Input style={{ width: 80 }} />)}
              </Col>
            </Row>

          </FilterItem>
          {/* <FilterItem className={styles.row} label="申诉状态">
            {getFieldDecorator('appeal_state', {
              initialValue: query.appeal_state || null,
            })(
              <Select style={{ width: 120 }}>
                <Select.Option value={null}>全部</Select.Option>
                <Select.Option value="1">待受理</Select.Option>
                <Select.Option value="2">完结</Select.Option>
                <Select.Option value="3">驳回</Select.Option>
              </Select>
            )}
          </FilterItem> */}


          <FilterItem className={styles.row} label="创建日期">
            {getFieldDecorator('time_range', {
              initialValue: query.time_range
                ? [dayjs(+query.time_range[0]), dayjs(+query.time_range[1])]
                : [0, 0],
            })(<RangePicker style={{ width: 240 }} />)}
          </FilterItem>
          <FilterItem className={styles.row} label="结算日期">
            {getFieldDecorator('time_range2', {
              initialValue: query.time_range2
                ? [dayjs(+query.time_range2[0]), dayjs(+query.time_range2[1])]
                : [0, 0],
            })(<RangePicker style={{ width: 240 }} />)}
          </FilterItem>
          <FilterItem className={styles.row} label="工单评价">
            {getFieldDecorator('comment_flag', {
              initialValue: query.comment_flag || null,
            })(
              <Select style={{ width: 120 }}>
                <Select.Option value={null}>全部</Select.Option>
                <Select.Option value="1">好评</Select.Option>
                <Select.Option value="2">差评</Select.Option>
              </Select>
            )}
          </FilterItem>
          <FilterItem className={styles.row} label="索赔/申诉">
            {getFieldDecorator('ss_flag', {
              initialValue: query.ss_flag || null,
            })(
              <Select style={{ width: 120 }}>
                <Select.Option value={null}>全部</Select.Option>
                <Select.Option value="1">索赔</Select.Option>
                <Select.Option value="2">申诉</Select.Option>
              </Select>
            )}
          </FilterItem>
          <FilterItem className={styles.row} label="工单标记颜色">
            {getFieldDecorator('tag_flag', {
              initialValue: query.appeal_state || null,
            })(
              <Select style={{ width: 120 }}>
                <Select.Option value={null}>全部</Select.Option>
                <Select.Option value="1">无标记</Select.Option>
                <Select.Option value="2">红色</Select.Option>
                <Select.Option value="3">黄色</Select.Option>
                <Select.Option value="4">粉色</Select.Option>
                <Select.Option value="5">绿色</Select.Option>
                <Select.Option value="6">蓝色</Select.Option>
              </Select>
            )}
          </FilterItem>
          <FilterItem className={styles.row} label="标签">
            {getFieldDecorator('tags', {
              initialValue: query.tags || null,
            })(<Checkbox.Group options={tenantMode ? tenantOrderTagsOptions : managerOrderTagsOptions} />)}
          </FilterItem>
          <FilterItem className={styles.row} label="验证码交单">
            {getFieldDecorator('captchas')(<Checkbox.Group options={orderCaptchaOptions} />)}
          </FilterItem>
          <FilterItem className={styles.row} label="是否返件">
            {getFieldDecorator('is_return')(<Checkbox.Group options={orderCaptchaOptions} />)}
          </FilterItem>
          {!tenantMode && (
            <FilterItem className={styles.row} label="是否亏损">
              {getFieldDecorator('is_loss')(<Checkbox.Group options={orderCaptchaOptions} />)}
            </FilterItem>)}
          <FilterItem className={styles.row} label="是否使用代金券">
            {getFieldDecorator('coupons')(<Checkbox.Group options={orderCaptchaOptions} />)}
          </FilterItem>

          {tenantMode && <>
            <FilterItem className={styles.row} label="工单编号">
              {getFieldDecorator('order_number', {
                initialValue: query.order_number || null,
              })(<Input style={{ width: 160 }} placeholder="请输入工单编号" suffix={
                <Icon type="search" />
              } />)}
            </FilterItem>

            <FilterItem className={styles.row} label="店铺名称">
              {getFieldDecorator('order_source', {
                initialValue: query.order_source || null,
              })(<Input style={{ width: 160 }} placeholder="请输入店铺名称" suffix={
                <Icon type="search" />
              } />)}
            </FilterItem>

            <FilterItem className={styles.row} label="产品名称">
              {getFieldDecorator('product', {
                initialValue: query.product || null,
              })(<Input style={{ width: 160 }} placeholder="请输入产品名称" suffix={
                <Icon type="search" />
              } />)}
            </FilterItem>
          </>}

          <FilterItem className={styles.row}>
            <div className={styles.submitBtns}>
              <Tooltip title="注意：将下载当前查询条件内所有数据（无需再次按页下载）">
                <Button type="link" href={downloadUrl}>
                  下载
                </Button>
              </Tooltip>
            </div>
          </FilterItem>
        </div>
      </Form>
    );
  }
}
